<template>
  <div class="card-body p-4">
    <slot></slot>
  </div>
</template>

<style scoped></style>
